
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './Kpis.module.css';

const Kpis = ({ title, value }) => {
  return (
  <div className={styles['stat-tile']}>
  <div className={styles['tile-header']}>{title}</div>
  <div className={styles['tile-body']}>
    <div className={styles['tile-value']}>{value}</div>
  </div>
  <div className={styles['tile-footer']} />
</div>
  );
};

Kpis.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
 
};

Kpis.defaultProps = {
  isPositive: true
};

export default Kpis;
